import { StoredCustomer } from "src/app/storage/models/stored-orders/stored-customer";

/**
 * An instance of the StoredCustomer model to be used for schema validation
 */
export const storedCustomerInstance: StoredCustomer = {
	Name: "",
	Terminal: ""
}